<template>
  <div>
    <CAlert 
      class="w-50 mx-auto mt-5 fixed-top"
      :color="alert.color" 
      :closeButton="!(typeof(alert.show) === 'number')"
      :show.sync="alert.show"
      @update:show="(value) => alertEvent(value)">
      {{ alert.message }}   
      <CProgress v-if="typeof(alert.show) === 'number'"
        class="my-3"
        height="3px"
        animate
        :max="5"
        :value="alert.show"
        :color="alert.color"
      />         
    </CAlert>
    
    <main class="login-container">
      <section class="bg-section">
        <div class="slide" id="slide-1">
          <img src="../../public/static/img/background/00_ux-indonesia.jpg">
        </div>
        <div class="slide" id="slide-2">
          <img src="../../public/static/img/background/01_christina-wocintechchat.jpg">
        </div>
        <div class="slide" id="slide-3">
          <img src="../../public/static/img/background/02_christina-wocintechchat.jpg">
        </div>
        <div class="slide" id="slide-4">
          <img src="../../public/static/img/background/03_tribesh-kayastha.jpg">
        </div>
        <div class="slide" id="slide-5">
          <img src="../../public/static/img/background/04_towfiqu-barbhuiya.jpg">
        </div>
        <div class="slide" id="slide-6">
          <img src="../../public/static/img/background/05_thisisengineering.jpg">
        </div>
        <div class="slide" id="slide-7">
          <img src="../../public/static/img/background/06_tezos-frkusi.jpg">
        </div>
        <div class="slide" id="slide-8">
          <img src="../../public/static/img/background/07_colegas-dando-golpe-puno.jpg">
        </div>
        <div class="slide" id="slide-9">
          <img src="../../public/static/img/background/08_jakob-owens.jpg">
        </div>
        <div class="slide" id="slide-10">
          <img src="../../public/static/img/background/09_lala-azizli.jpg">
        </div>
        <div class="slide" id="slide-11">
          <img src="../../public/static/img/background/10_israel-andrade.jpg">
        </div>
        <div class="slide" id="slide-12">
          <img src="../../public/static/img/background/11_kristin-wilson.jpg">
        </div>
        <div class="slide" id="slide-13">
          <img src="../../public/static/img/background/12_empresarios-trabajan.jpg">
        </div>
      </section>
      <section class="login-wrapper">
        <section class="login-panel">
          <div class="login-panel-logo">
            <img src="../../public/static/logo_optimo_login.png" />
          </div>
          <div class="login-box">
            <p class="login-subtitle">So Easy, So Good!</p>
            <form v-on:keyup.enter="!validate ? attempLogin() : ''">
              <div class="mb-3">
                <label class="form-label">USUARIO</label>
                <div class="input-icon-group">
                  <User />
                  <input type="text" class="form-control custom-input" placeholder="usuario" v-model="userIdentification">
                </div>
              </div>
              <div class="mb-3">
                <label class="form-label">CONTRASEÑA</label>
                <div class="input-icon-group">
                  <Lock />
                  <input type="password" class="form-control custom-input" placeholder="••••••••" v-model="psswrd" @keyup.enter="attempLogin">
                </div>
              </div>
              <CButton 
                color="primary" 
                class="btn-login col-12"
                :disabled="validate"
                :class="validate ? 'disabled' : ''"
                @click="attempLogin()">
                <i class="bi bi-box-arrow-in-right mr-2"></i>
                INICIAR SESI&Oacute;N
              </CButton>
              <div class="mb-3 text-center" @click="showModal=true">
                <a href="#" class="text-muted link-primary form-label">Recuperar contraseña</a>
              </div>
            </form>
          </div>
        </section>
        <footer class="login-footer">
          <span class="text-muted">SICyA Software SAS &copy; 2026. Todos los derechos reservados.</span>
        </footer>

        <LoadingCover spinner="bullets" message="" v-show="loading" />
      </section>
    </main>
  </div>
</template>

<style scoped>
  @import "../assets/css/loginnew.css";
</style>

<script>
  import { ref } from "vue";
  import { Lock, User } from "lucide-vue";
  import moment from "moment";
  import LoadingCover from "@/components/containers/LoadingCover.vue";

  import { 
    getKey, 
    grabaAccesoUsuario,
    dataUsuarioSession,
    actualizaSesionUsuario,
    solicitaClaveUsuario
  } from "@/api";
  import {
    getRoutesModel,
    user_uid
  } from "@/general";

  export default {
    name: "Login",
    components: {
      Lock,
      User,
      LoadingCover
    },
    data(){
      return {
        loading: false,
        showModal: false,
        contador: 0,
        userIdentification: "",
        psswrd: ""
      }
    },
    methods: {
      async attempLogin(){
        this.loading = true;

        try {
          let initPath;

          const { token, refresh } = await getKey(this.userIdentification, this.psswrd)
          const { response } = await dataUsuarioSession(this, token)
          const userData = response
          const routesModel = await getRoutesModel();
          
          await grabaAccesoUsuario(this, this.userIdentification, true)

          this.$store.commit('setUserValue', ['token', token]);
          this.$store.commit('setUserValue', ['tokenRefresh', refresh]);
          this.$store.commit('setUserValue', ['isLoggedIn', true]);
          this.$store.commit('setUserValue', ['logginDate', moment().format()]);
          this.$store.commit('setUserValue', ['type', userData.tipo_Usuario]);
          this.$store.commit("setUserValue", ["data", {
            ...userData,
            routesAccessModel: routesModel
          }]);

          if (userData.tipo_Usuario === "E") {
            if (userData.tipo_Empleado === "V") {
              initPath = routesModel.find(item => item.path === "/comercial").children.find(item => item.name === "Inicio").path;
            } else {
              initPath = routesModel.find(item => item.path === "/administracion").children.find(item => item.name === "Inicio").path;
            }
            
            await this.updateSessionStatus();
          } else {
            initPath = routesModel.find(item => item.path === "/cliente").children.find(item => item.name === "Inicio").path;
          }

          this.$router.push({ path: initPath });
        } catch (error) {
          const errorMessage = error.response.status == 401 ? "Usuario o contraseña incorrectos." : `Ocurrio un error al iniciar sesión. Error: ${error.response.status} - ${error.response.statusText}`
          await grabaAccesoUsuario(this, this.userIdentification, false)
          
          this.$store.commit("setAlert", {
            color: "danger",
            message: errorMessage,
            show: 5
          });
        } finally {
          this.loading = false
        }
      },
      async updateSessionStatus() {
        try{
          await actualizaSesionUsuario(this, user_uid(), "A");
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: `NO se pudo actualizar el estado de la sesión. Error: ${error.response.status} - ${error.response.statusText}`,
            show: 5
          })
        }
      },
      async recoveryPassword() {
        try {
          this.loading = true

          await solicitaClaveUsuario(this.userIdentification);
        } catch(error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Ocurrio un error en la recuperacion de contraseña.",
            show: 5
          })
        } finally {
          this.loading = false;
          this.showModal = false;
        }
      },
      alertEvent(value) {
        if (typeof(value) == 'boolean') {    
          this.$store.commit('setAlert',{ show: false })
        } else {
          if (!value) {
            this.$store.commit('setAlert',{ show: false })
          }
        }
      },
      // setAlert(value) {
      //   this.$store.commit(
      //     'setAlert', { 
      //       color: value ? 'success' : 'danger',
      //       message: value ? 'Acción exitosa' : 'No se pudo iniciar sesión',
      //       show: 5 
      //     }
      //   )
      // },
      setImageBackground() {
        document.getElementById(`slide-${this.currentSlide}`).classList.remove('active-slide');

        // this.currentSlide = (this.currentSlide % 9) + 1;
        this.currentSlide = Math.floor(Math.random() * this.totalSlides) + 1;

        document.getElementById(`slide-${this.currentSlide}`).classList.add('active-slide');
      }
    },
    computed:{
      alert() {
        return this.$store.state.alert
      },
      validate() {
        return (this.psswrd.length == 0) || (this.userIdentification.length == 0);
      }
    },
    setup() {
      const currentSlide = ref(1);
      const totalSlides = ref(13);

      return {
        currentSlide,
        totalSlides
      }
    },
    mounted() {
      // this.$forceUpdate()
      this.currentSlide = Math.floor(Math.random() * this.totalSlides) + 1;

      document.getElementById(`slide-${this.currentSlide}`).classList.add("active-slide");

      this.pollingInterval = setInterval(this.setImageBackground, 5000);
    },
    beforeDestroy() {
      clearInterval(this.pollingInterval);
    }
  }
</script>